import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../app/store";
import axiosInstance from "../../../../configs/axios/axios ";
import {
  GET_DIR,
  SEARCH_FILE_FOLDER,
} from "../../../../configs/axios/constantsAPI";
import { getCookie } from "../../../../configs/cookie-helper/cookieHelper";

export const getDirectoryAction = createAsyncThunk(
  "directory/getDirectory",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        GET_DIR,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const searchDirectoryAction = createAsyncThunk(
  "directory/searchDirectory",
  async (sendData: any, { rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        SEARCH_FILE_FOLDER,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

interface History {
  name: string;
  path: string;
  id: string;
}

export interface Items {
  dir: boolean;
  id: string;
  name: string;
  size: string;
  type: string;
  path: string;
}

export interface DirectoryState {
  directoryData: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    path: string;
    idfolder: string;
    history: Array<History>;
    items: Array<Items>;
  };
  searchData: {
    actionStatus: string;
    alert: {
      error: boolean;
      message: string;
    };
    items: Array<Items>;
  };
  searchInput: string;
  listView: boolean;
}

const initialState: DirectoryState = {
  directoryData: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    path: "",
    idfolder: "0",
    history: [],
    items: [],
  },
  searchData: {
    actionStatus: "",
    alert: {
      error: false,
      message: "",
    },
    items: [],
  },
  searchInput: "",
  listView: false,
};

export const directorySlice = createSlice({
  name: "directory",
  initialState,
  reducers: {
    directoryListViewAction: (state, action: PayloadAction<boolean>) => {
      state.listView = action.payload;
    },
    searchInputAction: (state, action: PayloadAction<string>) => {
      state.searchInput = action.payload;
    },
    resetSearchDirectoryAction: (state) => {
      state.searchData = initialState.searchData;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(getDirectoryAction.pending, (state) => {
      state.directoryData.actionStatus = "loading";
      state.directoryData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(getDirectoryAction.fulfilled, (state, { payload }) => {
      state.directoryData.actionStatus = "success";
      state.directoryData.alert = {
        error: payload.content?.error,
        message: payload.content?.error
          ? payload.content?.message === "login_again"
            ? "login_again"
            : payload.content?.message
          : "Great, we didn't encounter any errors!",
      };
      state.directoryData.path = payload.content?.path?.path
        ?.split("/")
        .filter((item: string, index: number) => index > 1)
        .join("/");
      state.directoryData.idfolder = payload.content?.idfolder;
      state.directoryData.history = payload.content?.path?.history;
      let newItems = [];
      for (let i = 0; i < payload.content.files?.length; i++) {
        const makedPath = {
          ...payload.content.files[i],
          path: payload.content.files[i].path
            ?.split("/")
            .filter((item: string, index: number) => index > 2)
            .join("/")
            ? `/${payload.content.files[i].path
                ?.split("/")
                .filter((item: string, index: number) => index > 2)
                .join("/")}`
            : "",
        };
        newItems.push(makedPath);
      }
      state.directoryData.items = newItems;
    });
    addCase(getDirectoryAction.rejected, (state, { payload }: any) => {
      state.directoryData.actionStatus = "rejected";
      state.directoryData.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });

    addCase(searchDirectoryAction.pending, (state) => {
      state.searchData.actionStatus = "loading";
      state.searchData.alert = {
        error: false,
        message: "",
      };
    });
    addCase(searchDirectoryAction.fulfilled, (state, { payload }) => {
      state.searchData.actionStatus = "success";
      state.searchData.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
      let newItems = [];
      for (let i = 0; i < payload.content.files?.length; i++) {
        const makedPath = {
          ...payload.content.files[i],
          path: payload.content.files[i].path
            ?.split("/")
            .filter((item: string, index: number) => index > 2)
            .join("/")
            ? `/${payload.content.files[i].path
                ?.split("/")
                .filter((item: string, index: number) => index > 2)
                .join("/")}`
            : "",
        };
        newItems.push(makedPath);
      }
      state.searchData.items = newItems;
    });
    addCase(searchDirectoryAction.rejected, (state, { payload }: any) => {
      state.searchData.actionStatus = "rejected";
      state.searchData.alert = {
        error: payload.content.error,
        message: payload.content.error
          ? "Sorry, we encountered an error!"
          : "Great, we didn't encounter any errors!",
      };
    });
  },
});

export const {
  directoryListViewAction,
  searchInputAction,
  resetSearchDirectoryAction,
} = directorySlice.actions;

export const directory = (state: RootState) => state.directoryState;

export default directorySlice.reducer;
